import React from "react";
import { Loader2 } from "lucide-react";

interface AvatarDisplayProps {
  avatarUrl: string | null;
  initials: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "subtle";
  uploading?: boolean;
}

export const AvatarDisplay: React.FC<AvatarDisplayProps> = ({
  avatarUrl,
  initials,
  size = "md",
  variant = "default",
  uploading = false,
}) => {
  const sizeClasses = {
    sm: "w-12 h-12 text-lg",
    md: "w-20 h-20 text-2xl",
    lg: "w-32 h-32 text-4xl",
  };

  const className = `${sizeClasses[size]} rounded-2xl flex items-center justify-center overflow-hidden relative`;
  const fallbackClasses =
    variant === "subtle"
      ? "bg-gradient-to-br from-pink-400/55 via-fuchsia-400/40 to-violet-400/25 border border-pink-300/55 shadow-[0_0_0_1px_rgba(255,255,255,0.12)_inset,0_14px_30px_-18px_rgba(236,72,153,0.7)] text-white"
      : "bg-gradient-to-br from-purple-500 via-pink-500 to-purple-600";

  return (
    <div className={className}>
      {avatarUrl ? (
        <>
          <img
            src={avatarUrl}
            alt="Profile"
            className="w-full h-full object-cover"
          />
          {uploading && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <Loader2 className="w-6 h-6 text-white animate-spin" />
            </div>
          )}
        </>
      ) : (
        <div
          className={`w-full h-full flex items-center justify-center ${fallbackClasses}`}
        >
          {uploading ? (
            <Loader2 className="w-8 h-8 text-white animate-spin" />
          ) : (
            <span className="font-bold text-white">{initials}</span>
          )}
        </div>
      )}
    </div>
  );
};
